import React, { Component } from "react";
import ReactDOM from "react-dom";
import moment from "moment";
import { connect } from "react-redux";
import { compose } from "redux";
import { FiBell } from "react-icons/fi";
import { MdClose } from "react-icons/md";
import "../styles/components/notificationBell.scss";
import { Row, Col } from "react-flexbox-grid";
import { Popover, Overlay } from "react-bootstrap";
import {calendarFunctions} from '../helpers/calendar-functions'
import { Notification } from "../components/Notification";
import { createEvent } from "../actions/events-actions";
import { setNotifications } from '../actions/user-actions';

class NotificationBell extends Component {
  bellRef = null;
  constructor(props) {
    super(props);

    this.state = {
      showOverlay: false,
      todayEvents: [],
      event: {},
      notifications: []
    };
  }
  
  componentDidUpdate(prevProps) {
    const { eventsToShow } = this.props;
    const todayDate = moment().local();
    let newTodayEvents = [];
    let notifications = [];
    let totalTodayEvents = 0;

    //If there are new events created or previous events were edited update the notifications list
    if(eventsToShow !== prevProps.eventsToShow){
      //Kill all the timeouts that were previously setted 
       this.state.notifications.forEach(timeout => {
         clearTimeout(timeout)
       })

      
      eventsToShow.forEach((event, index) => {
        let reminderDate = moment(event.reminderDate);
        const isSameDay = todayDate.format("YYYY-MM-DD") === reminderDate.format("YYYY-MM-DD");

        //Check if the reminder date of the event matches with today Date and hasnt been mark as read
        if (isSameDay && (event.reminderDate) && !event.read) {
          let shouldNotifyEvent = moment(event.reminderDate).isAfter(todayDate);
          let diff = moment(event.reminderDate).diff(moment(), "milliseconds");
          
          //Set a timeout if the reminderDate time (Hour minutes) has not happened
          if(shouldNotifyEvent){
            //create a timeout, that update the counter of notifications, after state has been setted update the events that will be displayed
            let timeout = setTimeout(() => {
                totalTodayEvents += 1;
                newTodayEvents.push(event)
                this.props.setNotifications(totalTodayEvents)
            }, diff);
            //Add the timeout in notifications array, so it can track all the scheduled notifications
            notifications.push(timeout);
          } else {
            //if the reminder had happened, update the events to show
            newTodayEvents.push(event)
            totalTodayEvents += 1;
          }
          //update all the events and the new timeouts generated, after an event was created or updated
          this.setState({
            todayEvents: newTodayEvents,
            notifications: notifications,
          })
        }
      });
        this.props.setNotifications(totalTodayEvents)
    }
  }

  markRecurrenceAsSeen = (event) => {
    let updateEvents = [...this.state.todayEvents];
    const newData = calendarFunctions.markRecurrenceAsSeen(this.props.recurrentEvents, event);
    const sortKey = "recurrentEvents"
    this.executeUpdate(sortKey, newData, false);
    updateEvents = updateEvents.filter((ev) => {return ev.id !== event.id})
    this.setState({
      todayEvents: updateEvents
    })
  }

  markAsSeen = (event) => {
    let updateEvents = [...this.state.todayEvents];
    const newData = calendarFunctions.markSimpleAsSeen(this.props.events, event)
    const sortKey = moment(event.start).format('YYYY-MM')
    this.executeUpdate(sortKey, newData, false);
    updateEvents = updateEvents.filter((ev) => {return ev.id !== event.id})
    this.setState({
      todayEvents: updateEvents
    })
  }

  handleShowOverlay = () => {
    this.setState({
      showOverlay: !this.state.showOverlay,
    });
  };

  executeUpdate = (sortKey, events, create) => {
    const data = {
        email: this.props.user.email,
        sortKey,
        events: calendarFunctions.removeCalendarProps(events),
        create: create
    }

    this.props.updateEvents(data)
  }

  render() {
    const { showOverlay } = this.state;
    const { totalNotifications } = this.props;
    return (
        <div
          className={["__bell", showOverlay ? "open" : "closed", 'step14-calendar'].join(" ")}
          ref={div => {
            this.bellRef = div;
          }}
          onClick={this.handleShowOverlay}
        >
          <FiBell size="28" />
          {totalNotifications > 0 &&
            <span className={"__badge"}>{totalNotifications > 9 ? '9+' : totalNotifications}</span>
            }
          <Overlay
            onHide={() => this.setState({ showOverlay: false })}
            rootClose
            target={() => ReactDOM.findDOMNode(this.bellRef)}
            show={showOverlay}
            placement="bottom"
          >
            <Popover
              id="notificationsContainer"
              className={"notificationsPopover"}
            >
              <Popover.Title as="h3">
                <Row>
                  <Col xs={10} className="notificationsTitle">
                    <span>Notifications </span>
                  </Col>
                  <Col xs={2} className={"closeNotifications"}>
                    <MdClose style={{ color: "red" }} size="24" />
                  </Col>
                </Row>
              </Popover.Title>
              <Popover.Content>
                {this.state.todayEvents.length ? this.state.todayEvents.map((event, index )=> {
                  return <Notification event={event} markAsSeen={event.hasOwnProperty('recurrenceRule') ? this.markRecurrenceAsSeen :  this.markAsSeen} displayModal={this.props.displayModal}/>;
                }) : <Row center="xs"><Col xs={8}><small>There are no notifications</small></Col></Row>}
              </Popover.Content>
            </Popover>
          </Overlay>
        </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.userReducer.user,
    events: state.eventsReducer.events,
    eventsToShow: state.eventsReducer.eventsToShow,
    recurrentEvents: state.eventsReducer.recurrentEvents,
    errorType: state.eventsReducer.errorStatus,
    updateEventsSuccess: state.eventsReducer.updateEventsSuccess,
    updateEventsError: state.eventsReducer.updateEventsError,
    errorMessage: state.eventsReducer.errorMessage,
    saving: state.eventsReducer.saving,
    loading: state.eventsReducer.loading,
    deleting: state.eventsReducer.deleting,
    deleteEventsSuccess: state.eventsReducer.deleteEventsSuccess,
    totalNotifications: state.userReducer.totalNotifications
  };
};

const mapDispatchToProps = dispatch => {
  return {
    updateEvents: (data) => dispatch(createEvent(data)),
    setNotifications: (data)  => dispatch(setNotifications(data))
  };
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  NotificationBell
);
